
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // import Puzzle from "../../modules/puzzle/Puzzle";
// import { puzzleApi } from "../../services/api";
// // import Redis from "ioredis";
// // import { getRandomPuzzle } from "../../util/puzzle";
// // const redis = new Redis();
// export async function getStaticPaths() {
//   // const response = await api.get("/puzzleIds");
//   // let puzzleIds = response.data.puzzleIds;
//   // const paths = puzzleIds.map((puzzleId) => ({
//   //   params: { id: puzzleId.toString() },
//   // }));
//   return {
//     paths: [],
//     fallback: true,
//   };
// }
// export async function getStaticProps({ params }) {
//   const { id } = params;
//   // let puzzles = await redis.get("puzzles" + id);
//   // if (puzzles) {
//   //   puzzles = JSON.parse(puzzles);
//   // } else {
//   let puzzles;
//   try {
//     const response = await puzzleApi.get("/puzzles/" + id);
//     puzzles = response.data.puzzles;
//     // const puzzleStr = JSON.stringify(puzzles);
//     // redis.set("puzzles" + id, puzzleStr, "EX", 31556952);
//   } catch (e) {
//     console.log("Error in puzzles", id);
//   }
//   // if (!puzzles) {
//   //   const response = await api.get("/puzzles");
//   //   puzzles = response.data.puzzles;
//   // }
//   let nextPuzzleId = 6497;
//   try {
//     const response = await puzzleApi.get("/puzzleIds/random");
//     nextPuzzleId = response.data.randomPuzzleId;
//   } catch (e) {
//     console.log("error in puzzles");
//   }
//   return {
//     props: {
//       puzzles,
//       nextPuzzleId,
//       index: false,
//     },
//     revalidate: 86400,
//   };
// }
// export default Puzzle;
import Puzzle from "../../modules/puzzle/Puzzle";
import { puzzleApi } from "../../services/api";
async function getServerSideProps({ params }) {
    const { id } = params;
    let puzzles;
    let nextPuzzleId = 6497;
    try {
        const response = await puzzleApi.get("/puzzles/" + id);
        puzzles = response.data.puzzles;
    }
    catch (e) {
        console.log("Error in puzzles", id);
    }
    try {
        const response = await puzzleApi.get("/puzzleIds/random");
        nextPuzzleId = response.data.randomPuzzleId;
    }
    catch (e) {
        console.log("Error in random puzzle ID");
    }
    return {
        props: {
            puzzles,
            nextPuzzleId,
            index: false,
        },
    };
}
export default Puzzle;

    async function __Next_Translate__getServerSideProps__19af9d029c8__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19af9d029c8__ as getServerSideProps }
  